import $ from "jquery";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

class Showcase {
    timeline = null;

    constructor() {
        this.init();
    }

    init() {
        if (this.dom()) {
            gsap.registerPlugin(ScrollTrigger);

            this.destroy();
            this.setup();
        }
    }

    dom() {
        this.$showcases = $('.showcase');
        this.$showcaseFigures = $('.showcase-figure');

        return (
            this.$showcases.length > 0 &&
            this.$showcaseFigures.length > 0
        );
    }

    setup() {
        if (this.timeline) return;

        this.$showcases.each((i) => {
            const $showcase = this.$showcases.eq(i);
            const $showcaseFigures = $showcase.find(this.$showcaseFigures);

            const mm = gsap.matchMedia();

            mm.add(Foundation.MediaQuery.get('large'), () => {
                this.timeline = gsap.timeline({
                    scrollTrigger: {
                        trigger: $showcase.get(0),
                        // start: "200px bottom", // kad je sredina elementa na dnu prozora
                        // end: "bottom bottom",
                        // end: '+=1000',
                        scrub: true,
                        pin: true,
                        // immediateRender: false
                    }
                });

                this.$showcaseFigures.each((i) => {
                    const $showcaseFigure = $showcaseFigures.eq(i);
                    const totalFigures = $showcaseFigures.length;
                    const totalDuration = 1;
                    
                    const duration = totalDuration / totalFigures;
                    const start = i * (duration / 2);

                    const positions = {
                        0: { left: "-600px", top: "0%" },
                        1: { left: "150%", top: "30%" },
                        2: { left: "150%", top: "100%" },
                    }

                    this.timeline.from($showcaseFigure.get(0), {
                        left: positions[i].left,
                        top: positions[i].top,
                        // width: "400px",
                        ease: "power2.inOut",
                        duration: duration,
                    }, start);
                });
            });
        });

        
    }

    destroy() {
        if (!this.timeline) return;

        this.timeline.scrollTrigger.kill();
        this.timeline.progress(0).kill();
        this.timeline = null;
    }
}

export default Showcase;
